export default "__VITE_ASSET__BfCzgB8G__"